import { render, staticRenderFns } from "./SurveyInsights.vue?vue&type=template&id=6c511174&"
import script from "./SurveyInsights.vue?vue&type=script&lang=js&"
export * from "./SurveyInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports